import { ApolloCache, useApolloClient } from "@apollo/client"

import { QueryTypename } from "shared/api/types"
import { useEvent } from "shared/lib/useEvent"
import { ProductConfigurationResponse } from "shared/types/__generated__/graphql"

import {
  ProductConfigurationDocument,
  ProductConfigurationQuery,
  ProductConfigurationQueryVariables
} from "entities/dim-configuration/graphql/product-configuration.queries.generated"
import { getProductConfigurationQueryVariables } from "entities/dim-configuration/lib/getProductConfigurationQueryVariables"

function updateCache(
  data: ProductConfigurationResponse,
  cache: ApolloCache<object>
) {
  cache.writeQuery<
    ProductConfigurationQuery,
    ProductConfigurationQueryVariables
  >({
    query: ProductConfigurationDocument,
    variables: getProductConfigurationQueryVariables({
      ...data,
      productType: data.productType ?? ""
    }),
    data: {
      __typename: QueryTypename,
      productConfiguration: data
    }
  })
  if (data.originalConfiguration) {
    updateCache(data.originalConfiguration, cache)
  }
}

export function useConfigurationKeyCache() {
  const { query, cache } = useApolloClient()

  return useEvent((data: ProductConfigurationResponse | null | undefined) => {
    if (data?.productType && data?.dimensioningKey) {
      query<ProductConfigurationQuery, ProductConfigurationQueryVariables>({
        query: ProductConfigurationDocument,
        variables: getProductConfigurationQueryVariables({
          productType: data.productType,
          configurationKey: data.configurationKey
        })
      })
    }
    if (data) {
      updateCache(data, cache)
    }
  })
}
